<template>
    <div class="form-container">
        <form class="form-signin bg-white" @submit.prevent="onSubmit" v-if="loading === false">

            <h1 class="h3 mb-3 font-weight-normal">Sign in</h1>

            <div class="form-group">
                <label for="inputUsername" class="sr-only">User</label>
                <input id="inputUsername"
                       class="form-control"
                       type="text"
                       placeholder="Username"
                       required="required"
                       autofocus=""
                       v-model="user.username">
            </div>

            <div class="form-group">
                <label for="inputPassword" class="sr-only">Password</label>
                <input id="inputPassword"
                       class="form-control"
                       type="password"
                       placeholder="Password"
                       required="required"
                       minlength="8"
                       v-model="user.password">
            </div>

            <button class="btn btn-lg btn-primary btn-block" type="submit">Sign in</button>

            <alert-component class="mt-3"/>

            <p class="mt-5 text-muted text-right"><small>© 2020</small></p>
        </form>

        <div class="form-signin" v-if="loading === true">
            <div class="col-12">
                <spinner-component class="p-5" type="spinner-grow"/>
            </div>
        </div>
    </div>
</template>

<script>
    import User from "@/models/user.model";
    import AlertComponent from "@/components/AlertComponent";
    import SpinnerComponent from "@/components/ui/SpinnerComponent";

    export default {
        name: "SignInPage",
        components: { SpinnerComponent, AlertComponent },
        data() {
            return {
                user: new User('', '', ''),
                loading: false
            }
        },
        methods: {
            onSubmit() {
                this.loading = true;

                this.$store.dispatch('alert/clear');
                this.$store.dispatch('rubyIdent/loginUser', this.user)
                    .then(result => {
                        Promise.resolve(result);
                    })
                    .catch(error => {
                        Promise.reject(error);
                        this.loading = false;
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form-container {
        height: 100%;
        display: -ms-flexbox;
        display: flex;
        -ms-flex-align: center;
        align-items: center;
    }

    .form-signin {
        width: 100%;
        max-width: 480px;
        padding: 5em 3em;
        margin: auto;
        box-shadow: 0 0 40px #F0F3FF;

        .checkbox {
            font-weight: 400;
        }

        .form-control {
            position: relative;
            box-sizing: border-box;
            height: auto;
            padding: 10px;
            font-size: 16px;

            &:focus {
                z-index: 2;
            }
        }

        input[type="email"] {
            margin-bottom: -1px;
        }

        input[type="password"] {
            margin-bottom: 10px;
        }
    }
</style>